import React from "react";

type PlayIconProps = {
  className?: string;
  color?: string;
  onClick?: () => void;
  size?: number;
};

const PlayIcon = ({ size = 24, color = 'white', className, onClick }: PlayIconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 9.99442V15.0056C6 18.1211 8.68571 19.388 11.9657 17.8396L13.4286 17.1452C13.7829 16.9763 17.5 14.6712 14.5 16L14 8.67125C14 8.33341 13.7829 8.02374 13.4286 7.85482L11.9657 7.16039C8.68571 5.612 6 6.87886 6 9.99442Z" fill={color}/>
<path d="M13.9994 8.99818V15.9582C13.9994 16.3776 14.4192 16.6357 14.749 16.4206L15.8483 15.7323C18.7165 13.9577 18.7165 11.0324 15.8483 9.25779L13.4993 7.99818C13.1696 7.79383 13.9994 8.57873 13.9994 8.99818Z" fill={color}/>
</svg>

);

export default PlayIcon;
